require('./accountSettlementsDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountSettlementsDetailsTableRow = require('./accountSettlementsDetailsTableRow/accountSettlementsDetailsTableRow');
// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class AccountSettlementsDetails extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildTable() {
        const { immSettlementsDetails } = this.props;

        return (
            <LastMovementsTable
                groupByDate={false}
                rowComponent={AccountSettlementsDetailsTableRow}
                immTransactionsByOrder={immSettlementsDetails.get('byOrder')}
                immTransactionsById={immSettlementsDetails.get('byId')}
                columnsCount={4}
                id="account-settlements-details"
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                language={language}
            >
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountSettlementsDetails-period"/>
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountSettlementsDetails-concept"/>
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="account-settlements-details__table-cells-header--right">
                            <FormattedText
                                value="accountSettlementsDetails-rate"
                                format="firstUppercase"
                            />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="account-settlements-details__table-cells-header--right">
                            <FormattedText
                                value="accountSettlementsDetails-import"
                                format="firstUppercase"
                            />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            </LastMovementsTable>
        )
    }

    render() {
        const { immSettlementsDetails } = this.props;
        let content;


        if (immSettlementsDetails.get('hasBeenFetched')) {
            const tableContent = this.buildTable();
            const headerTitle = formatText('accountSettlementsDetails-settlement');

            content = (
                <div className="account-settlements-details__table">
                    <header className="account-settlements-details__header">
                        <OKBoxTitle value={headerTitle} />
                    </header>
                    {tableContent}
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

AccountSettlementsDetails.propTypes = {
    immSettlementsDetails: PropTypes.object
};

module.exports = AccountSettlementsDetails;
